/**
 * @file 获取图片上传者列表
 * @author liudy
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

interface IInput {
    element_id: number;
    page: number;
    size: number;
}

export type IPhotoAuthor = IUserBaseInfo & {
    user_id?: string;
};

export const getPhotoAuthors = (data: IInput): Promise<IListResponse<IPhotoAuthor>> => {
    return fetchData(Api.PHOTO_GET_PHOTO_AUTHOR_LIST, data).then((res: IListResponse<IPhotoAuthor>) => {
        return res;
    });
};
